var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insurance-target-section"},[_c('ul',{staticClass:"insurance-target-section__list"},_vm._l((_vm.insuranceTargetCards),function(card){return _c('li',{key:card.iconName,staticClass:"insurance-target-section__item"},[_c('InsuranceTargetCard',{attrs:{"text-html":card.text,"icon-name":card.iconName}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }